import React, { ReactNode } from 'react';
import Tooltip from '@mui/material/Tooltip';
import type { BadgeProps } from '@mui/material/Badge';

import { BadgePulse } from './styles';

interface NewsFeatureBadgeProps extends BadgeProps {
  children?: ReactNode;
  tooltip?: ReactNode | string;
  top?: number;
  right?: number;
}

export const NewsFeatureBadge = ({
  children,
  tooltip,
  ...props
}: NewsFeatureBadgeProps) => {
  if (!tooltip)
    return (
      <BadgePulse badgeContent="Novidade" color="secondary" {...props}>
        {children}
      </BadgePulse>
    );

  return (
    <Tooltip title={tooltip} placement="right-start">
      <BadgePulse badgeContent="Novidade" color="secondary" {...props}>
        {children}
      </BadgePulse>
    </Tooltip>
  );
};
